/**
 * Subscription and product identifiers shared between API and UI.
 *
 * **SubscriptionTierId** — the effective access levels used for feature gating.
 * **PurchasableProductId** — every buyable line item in the Stripe catalogue.
 *
 * Display copy (name, description, feature bullets) lives in the i18n bundle
 * so that renaming a product is a single-file change. Only type-level
 * identifiers belong here.
 */
/** Access levels granted to a user (hierarchical: insider includes access includes free). */
export const SUBSCRIPTION_TIER_IDS = ['free', 'access', 'insider'];
/** Everything a user can buy (recurring subscriptions + one-time lifetime purchases). */
export const PURCHASABLE_PRODUCT_IDS = ['free', 'access', 'insider', 'vanguard', 'founder'];
/** The tiers that count as paid. `free` is a real tier, so a tier list alone is not enough. */
export const PAID_SUBSCRIPTION_TIER_IDS = ['access', 'insider'];
/**
 * Whether the holder has paid-level access through any mechanism: a paid
 * subscription tier, a lifetime purchase, or a `gifted` entitlement from
 * sponsorship.
 *
 * Shared so the client gates the same way the server enforces. Use this
 * everywhere a feature is restricted to non-free users, rather than testing
 * `subscriptions.length`, which is truthy for the `free` tier.
 */
export function hasPaidAccess(ctx) {
    if (ctx.isLifetime)
        return true;
    if (ctx.subscriptions?.some((tier) => PAID_SUBSCRIPTION_TIER_IDS.includes(tier)))
        return true;
    return ctx.entitlements?.includes('gifted') ?? false;
}
//# sourceMappingURL=tiers.js.map